<template>
  <div>
    <custom-actions :title="inventoryTypeMap.get(inventoryType) + '出入库管理'">
      <template #header>
        <el-button type="primary" v-visible="'add'" @click='onAdd2'>自由{{ ygTypeMap.get(searchForm.ygType) }}</el-button>
        <el-button type="primary" v-visible="'free'" @click='onAdd'>{{ ygTypeMap.get(searchForm.ygType) }}</el-button>
        <el-button type="primary" v-visible="'export'" @click="onExport">导出当前数据</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">
        <!-- <el-form-item prop="ygId" label="油罐名称">
          <el-select v-model="searchForm.ygId" clearable filterable placeholder="请选择油罐名称">
            <el-option v-for="(item, index) of guanList" :value="item.ygId" :label="item.ygCode"
              :key="index"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item prop="inventoryType" label="类型">
          <el-select v-model="searchForm.inventoryType" clearable filterable placeholder="请选择类型">
            <el-option v-for="([key, value], index) of inventoryTypeMap" :value="key" :label="value"
              :key="index"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item prop="" label="数据变更时间">
          <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click='onSearch'>查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-tabs v-model="searchForm.ygType" @tab-click="onSearch">
        <el-tab-pane :label="value" :name="key" v-for="([key, value], index) of ygTypeMap" :key="index"></el-tab-pane>
      </el-tabs>
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="120" v-if="inventoryType === '1'" show-overflow-tooltip label="油罐名称" prop="ygId"></el-table-column>
        <el-table-column min-width="120" v-if="inventoryType === '2'" show-overflow-tooltip label="商品名称" prop="goodsCodeName"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip :label="inventoryType === '1' ? '本次变化重量' : '数量'" prop="ygWeight"></el-table-column>
        <el-table-column min-width="120" v-if="inventoryType === '1'" show-overflow-tooltip label="本次变化液位" prop="ygLevel"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="关联用户" prop="userName"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="发货状态" prop="ygFhState">
          <template v-slot="{ row }">{{ ygFhStateMap.get(row.ygFhState) || '--' }}</template>
        </el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="记录状态" prop="ygNodeState">
          <template v-slot="{ row }">{{ ygNodeStateMap.get(row.ygNodeState) || '--' }}</template>
        </el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="司机姓名" prop="driverName"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="司机手机号" prop="driverMobile"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="车号牌" prop="vehicleKey"></el-table-column>
        <!-- <el-table-column show-overflow-tooltip label="类型1车辆2船" prop="vehicleType">
          <template v-slot="{ row }">{{ row.vehicleType === '1' ? '车辆' : '船' }}</template>
        </el-table-column> -->
        <el-table-column min-width="120" show-overflow-tooltip label="进场日期" prop="vehicleDate"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="进场时间" prop="vehicleTime">
          <template v-slot="{ row }">
            <span v-if="row.vehicleTime === '1'">上午</span>
            <span v-if="row.vehicleTime === '2'">下午</span>
            <span v-if="row.vehicleTime === '3'">夜晚</span>
          </template>
        </el-table-column>
        <!-- <el-table-column min-width="120" show-overflow-tooltip label="类型" prop="inventoryType">
          <template v-slot="{ row }">{{ inventoryTypeMap.get(row.inventoryType) || '--' }}</template>
        </el-table-column> -->
        <!-- <el-table-column show-overflow-tooltip label="油罐变化前液位" prop="ygUpLevel"></el-table-column>
        <el-table-column show-overflow-tooltip label="油罐变化后液位" prop="ygLevel"></el-table-column>
        <el-table-column show-overflow-tooltip label="油罐变化前温度" prop="ygUpTemperature"></el-table-column>
        <el-table-column show-overflow-tooltip label="油罐变化后温度" prop="ygTemperature"></el-table-column> -->
        <el-table-column min-width="120" show-overflow-tooltip label="运费单价" prop="shippingFee"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="备注" prop="ygNotes"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip label="数据变更时间" prop="ygTime"></el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/recordManage/detail?inventoryId=' + row.inventoryId)">详情</el-button>
            <el-button type="text" v-visible="'approve'" @click="$router.push('/recordManage/edit?inventoryId=' + row.inventoryId + '&approve=1&ygType=' + searchForm.ygType + '&inventoryType=' + inventoryType)"
              v-if="row.nodeRole === userInfo.roleId">审批</el-button>
            <el-button type="text" v-visible="'edit'"
              @click="$router.push('/recordManage/edit?inventoryId=' + row.inventoryId + '&ygType=' + searchForm.ygType + '&inventoryType=' + inventoryType)">编辑</el-button>
            <el-button type="text" v-visible="'del'" @click="deleteRow(row.inventoryId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { ygFhState, ygNodeState, inventoryType, ygType } from '@/utils/dict'
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'RecordManage',
  mixins: [keepAlive],
  data () {
    return {
      ygFhStateMap: ygFhState,
      ygNodeStateMap: ygNodeState,
      inventoryTypeMap: inventoryType,
      ygTypeMap: ygType,
      page: 1,
      total: 0,
      tableData: [],
      typeList: [
        {
          label: '收油',
          value: '1'
        },
        {
          label: '发油',
          value: '2'
        }
      ],
      loading: false,
      searchForm: {
        ygId: null,
        ygType: '1',
        inventoryType: ''
      },
      time: [],
      guanList: []
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user
    },
    inventoryType () {
      return this.$route.query.inventoryType
    }
  },
  watch: {
    inventoryType (val, oldValue) {
      if (val && oldValue) {
        this.searchForm.ygType = '1'
        this.searchForm.inventoryType = this.inventoryType
        this.loadData()
      }
    }
  },
  created () {
    // this.searchForm.inventoryType = this.inventoryType
    // this.loadData()
    // this.getGuan()
    this.searchForm.ygType = '1'
    this.searchForm.inventoryType = this.inventoryType
    this.loadData()
  },
  methods: {
    initData () {
      this.loadData()
    },
    onAdd () {
      const params = this.$qs.stringify({
        ygType: this.searchForm.ygType,
        inventoryType: this.inventoryType
      })
      this.$router.push(`/recordManage/add?${params}`)
    },
    onAdd2 () {
      const params = this.$qs.stringify({
        ygType: this.searchForm.ygType,
        inventoryType: this.inventoryType,
        free: '1'
      })
      this.$router.push(`/recordManage/add?${params}`)
    },
    getGuan () {
      this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByList).then(res => {
        this.guanList = res.list || []
      })
    },
    onExport () {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      let startDate = null
      let endDate = null
      if (this.time && this.time.length > 1) {
        startDate = this.time[0]
        endDate = this.time[1]
      }
      this.$axios.post(this.$apis.recordManage.exportYgInventoryReport, {
        ...this.searchForm,
        startDate,
        endDate
      }, {
        responseType: 'blob'
      }).then(res => {
        console.log('上传成功:', res)
        if (res) {
          const disposition = res.headers['content-disposition']
          const fileName = disposition.substring(disposition.indexOf('filename')).split('=')[1]
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    },
    downloadFile (data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      // 创建下载的链接
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      // 下载后文件名
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      // 释放掉blob对象
      window.URL.revokeObjectURL(href)
    },
    loadData () {
      this.loading = true
      let startDate = null
      let endDate = null
      if (this.time && this.time.length > 1) {
        startDate = this.time[0]
        endDate = this.time[1]
      }
      this.$axios.get(this.$apis.recordManage.selectYgInventoryByPage, {
        params: {
          page: this.page,
          ...this.searchForm,
          startDate,
          endDate
        }
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch () {
      this.page = 1
      this.loadData()
    },
    resetForm () {
      this.time = []
      // this.$refs.searchForm.resetFields()
      // this.searchForm = {
      //   ygId: null,
      //   ygType: ''
      // }
      this.onSearch()
    },
    deleteRow (inventoryId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.recordManage.deleteYgInventory, {
          inventoryId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'></style>
